var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 13 12"}},_vm.$listeners),[_c('path',{attrs:{"d":"M4.375 8.793l.707.707 3.536-3.536L5.082 2.43l-.707.707 2.828 2.828-2.828 2.829z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }